<template>
    <div class="position-box">
        <div class="head">
          <img class="back" src="@/assets/icon_back.png" @click="back" alt="">
          <div class="title">{{this.$t('langNew2.zb')}}</div>
          <div @click="jump2"><img class="icon" src="@/assets/dingdan.png" alt=""></div>
        </div>
        <div class="cont-box">
          <div class="select-box" @click="jump">
            <div class="text">{{this.$t('chongbi.xzbz')}}</div>
            <div class="bz">{{currency}}</div>
            <img class="arrow" src="@/assets/more2.png" alt="">
          </div>
          <ul class="ul-box">
              <li class="list" v-for="(item,index) in listData" :key="index">
                  <div class="list-head">
                      <div class="list-left">
                        <img class="bg1" v-if="index == 0" src="@/assets/button_03.png" alt="">
                        <img class="bg1" v-else-if="index == 1" src="@/assets/Primary-miner.png" alt="">
                        <img class="bg1" v-else-if="index == 2" src="@/assets/Secondary miner.png" alt="">
                        <img class="bg1" v-else-if="index == 3" src="@/assets/Three-stage-miner.png" alt="">
                        <img class="bg1" v-else-if="index == 4" src="@/assets/four-grade-miner.png" alt="">
                        <img class="bg1" v-else-if="index == 5" src="@/assets/Five-grade-miner.png" alt="">
                        <img class="bg1" v-else src="@/assets/Five-grade-miner.png" alt="">
                        <div class="text" @click="payJump(item,index)">{{$t('bzhlgm.rm')}}</div>
                      </div>
                      <div class="type money">{{$t('c2c.je')}} {{item.moneylimit}}</div>
                      <div class="type money2">{{$t('bzhl.zq')}} {{item.cycle}} {{$t('langNew.day')}}</div>
                      <div class="type money3">{{$t('langNew3.bzbz')}} {{item.currency}}</div>
                      <img class="xian1" src="@/assets/xian5.png" alt="">
                      <div class="star-box">
                        <div class="tips" v-if="lang == 'zh'">{{index+1}}{{$t('bzhl.dj')}}{{$t('jghy.sy')}}</div>
                        <div class="tips" v-else-if="lang == 'tw'">{{index+1}}{{$t('bzhl.dj')}}{{$t('jghy.sy')}}</div>
                        <div class="tips" v-else>{{$t('bzhl.dj')}} {{index+1}}</div>
                      </div>
                      <div class="list-right">
                          <div class="sl-box">
                              <vue-circle
                                  ref="myprogress"
                                  :progress="item.rate_win"
                                  :size="64"
                                  :reverse="false"
                                  line-cap="round"
                                  :fill="fill"
                                  empty-fill="rgba(11, 50, 59, 1)"
                                  :animation-start-value="0.0"
                                  :start-angle=" -Math.PI/2"
                                  insert-mode="append"
                                  :animation="{ duration: 1200, easing: 'easeOutBounce' }"
                                  :thickness="5"
                                  :show-percent="true"
                                  @vue-circle-progress="progress"
                                  @vue-circle-end="progress_end"
                                  >
                                  <p style="margin-top:0;font-size:12px;"></p>
                              </vue-circle>
                          </div>
                          <div class="sl-text">{{$t('langNew.syl')}}</div>
                      </div>
                      <div class="border border1"></div>
                      <div class="border border2"></div>
                      <div class="border border3"></div>
                      <div class="border border4"></div>
                  </div>
                  <img class="bg-line" src="@/assets/element.png" alt="">
              </li>
          </ul>
          <no-data v-show="hasData"></no-data>
          <!-- 返回顶部 -->
          <img id="goTop" class="go-top" @click="goTop" v-show="isGoTOP" src="@/assets/top.png" alt="">
        </div>
        <div class="mask" v-show="isMask"></div>
        <!-- 购买 -->
        <div class="alert-wrap3" v-show="isPay">
            <div class="tips">{{$t('langNew.tjdd')}}</div>
            <img class="btn-close" src="@/assets/close.png" @click="payClose" alt="">
            <ul class="ul-box">
                <li class="list">
                    <img class="img" v-if="level == 0" src="@/assets/button_03.png" alt="">
                    <img class="img" v-else-if="level == 1" src="@/assets/Primary-miner.png" alt="">
                    <img class="img" v-else-if="level == 2" src="@/assets/Secondary miner.png" alt="">
                    <img class="img" v-else-if="level == 3" src="@/assets/Three-stage-miner.png" alt="">
                    <img class="img" v-else-if="level == 4" src="@/assets/four-grade-miner.png" alt="">
                    <img class="img" v-else-if="level == 5" src="@/assets/Five-grade-miner.png" alt="">
                    <img class="img" v-else src="@/assets/button_03.png" alt="">
                    <div class="info-box">
                        <div class="title" v-if="lang == 'zh'">{{level+1}}{{$t('bzhl.dj')}}{{$t('jghy.sy')}}</div>
                        <div class="title" v-else-if="lang == 'tw'">{{level+1}}{{$t('bzhl.dj')}}{{$t('jghy.sy')}}</div>
                        <div class="title" v-else>{{$t('bzhl.dj')}} {{level+1}}</div>
                        <div class="price-box">
                            <div class="text1">{{$t('c2c.je')}} {{profit.moneylimit}}</div>
                            <div class="text2">{{$t('langNew.syl')}} {{profit.rate_win}}%</div>
                        </div>
                        <div class="sl-box">
                            <div class="text1">{{$t('bzhl.zq')}} {{profit.cycle}} {{$t('langNew.day')}}</div>
                            <div class="text2">{{$t('langNew3.bzbz')}} {{profit.currency}}</div>
                        </div>
                    </div>
                </li>
            </ul>
            <div class="money">{{$t('bzhlgm.tgje')}}</div>
            <div class="input-box"><input class="input" v-model="money" type="text" :placeholder="$t('bzhlgm.dbxe') + profit.moneylimit"></div>
            <div class="pay-box">
                <div class="t1">{{$t('pay.kyye')}} <span class="reds" v-if="currency == 'BTC'">{{useBalance | toFixed4}}<small> {{currency}}</small></span><span class="reds" v-else>{{useBalance | toFixed2}}<small> {{currency}}</small></span></div>
                <div class="t2" @click="buy">{{$t('c2c.ljtg')}}</div>
            </div>
        </div>
    </div>

</template>

<script>
import noData from '@/components/noData.vue'
import VueCircle from '@/pages/circle.vue'
let that = this;
export default {
    name: 'loan',
    data () {
        return {
          token: '',
          lang: 'en',
          currency: '',
          useBalance: 0,
          totlaMoney: 0,
          listData: [],
          profit: {},
          isMask: false,
          isPay: false,
          password: '',
          hasData: false,
          isGoTOP: false,
          curDataLength: 10,
          page: 1,
          limit: 10,
          fill : { gradient: ["#40D9FA"]},
          p:10,
          money: "",
          moneylimit: "",
          inputList: [
            { val: "" },
            { val: "" },
            { val: "" },
            { val: "" },
            { val: "" },
            { val: "" },
          ],
          level: 0,
          count: 1
        }
    },
    beforeCreate(){
        that = this;
    },
    created(){
      this.lang = localStorage.getItem('user_lang');
      this.token = localStorage.getItem('token');
      this.currency = this.$route.query.bz || 'USDC';
    },
    mounted() {
      this.getProfitList();
      this.getAsset();
    },
    methods: {
      back(){
        this.$router.push('/index')
      },
      jump(){
        this.$router.push('/selectAiBz')
      },
      jump2(){
        this.$router.push('/orderStatus?bz=' + this.currency)
      },
      getAsset(){
        let that = this;
        let params = {
          id: 1
        }
        this.$ajax.get('/web/getAsset2',{params}).then((res) => {
            let resData = res.data.data;
            if(res.data.code == 1000){
              setTimeout(()=>{
                this.$router.push('/index');
              },1000)
              return false
            }
            this.useBalance =  (Number(resData.list.filter(item =>{
              return item.currency == this.currency
            })[0].positions)).toFixed(4);
        }).catch(function(err){
            console.log(err)
        })
      },
      getProfitList(){
          let params = {
            currency: this.currency,
            page: this.page
          }
          this.$ajax.post('/web/getProfitList ',params).then((res) => {
              let resData = res.data.data;
              if(res.data.code == 0){
                var newArr = resData.map(item =>{
                  if(item.rate_win.split('-')[0]){
                    var obj2 = item.rate_win.split('-')[0];
                    item = { ...item,...obj2 };
                  }else{
                    var obj2 = {rate_win: item.rate_win};
                    item = { ...item,...obj2 };
                  }
                  return item
                });
                if(resData.length > 0){
                  this.hasData = false
                  this.listData = this.listData.concat(newArr);
                  this.curDataLength = resData.length;
                }else{
                  this.hasData = true;
                  this.curDataLength = resData.length;
                }
              }else{
                  this.$toast.center(res.data.message);
              }
          }).catch(function(err){
              console.log(err);
          })
      },
      progress(event,progress,stepValue){
          // console.log(stepValue);
      },
      progress_end(event){
          console.log("Circle progress end");
      },
      init(){
          let params = {
              uid: this.uid,
              token: this.token,
              limit: this.limit,
              page: this.page
          }
          this.$ajax.post('/api/miningmachine/mmIndex',params).then((res) => {
              let resData = res.data.data;
              if(res.data.code == 200){
                    if(resData.length > 0){
                      this.hasData = false
                      this.listData = resData;
                      this.$refs.scroll.forceUpdate(true)
                  }else{
                      this.hasData = true;
                  }
              }else{
                  this.$router.push('/login')
              }
          }).catch(function(err){
              console.log(err);
          })
      },
      getXys(){
            let params = {
              uid: this.uid,
              token: this.token,
              mm_id: this.mm_id,
              limit: this.limit,
              page: this.page2
          }
          this.$ajax.post('/api/Miningmachine/mmLuckyHistory',params).then((res) => {
              let resData = res.data.data;
              if(res.data.code == 200){
                  if(resData.length > 0){
                      this.xysListData = this.xysListData.concat(resData);
                      this.curDataLength = resData.length;
                  }else{
                      this.curDataLength = resData.length;
                  }
                  if(this.xysListData.length > 0){
                      this.hasData2 = false;
                  }else{
                      this.hasData2 = true;
                  }
              }else{
                  this.$router.push('/login')
              }
          }).catch(function(err){
              console.log(err);
          })
      },
      // 滚动到页面顶部
      scrollTo() {
          this.$refs.scroll.scrollTo(this.scrollToY, this.scrollToTime)
      },
      listenScroll(e) {  //监听滚动
        let ele = e.srcElement ? e.srcElement : e.target;
        if(ele.scrollTop > 200){
            this.isGoTOP = true
        }else{
            this.isGoTOP = false
        }
        if (ele.scrollTop + ele.offsetHeight >= ele.scrollHeight) { //监听滚动到div底部
            if(this.curDataLength > 0){
                this.page ++;
                this.getProfitList();
            }
        }
      },
      payClose(){
        this.isMask = false;
        this.isPay = false;
      },
      keyMoney(){
        this.money = this.money.replace(/[^\d.]/g, "");  //仅保留数字和"."
        this.money = this.money.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
        this.money = this.money.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
        this.money = this.money.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
        if (this.money.indexOf(".") < 0 && this.money != "") { //首位是0的话去掉
            this.money = parseFloat(this.money);
        }
      },
      payJump(item,idx){
        this.isPay = true;
        this.isMask = true;
        this.level = idx;
        this.profit = item;
      },
      buy(){
        var limitStart = parseFloat(this.profit.moneylimit.split('-')[0]);
        var limitEnd = parseFloat(this.profit.moneylimit.split('-')[1]);
         let params = {
            profit: this.profit.id,
            amount: this.money,
            tpassword: ''
          }
          if(this.count == 1){
            this.count = 0;
          }else{
            return false;
          }
          this.$ajax.post('/web/buyProfit',params).then((res) => {
              let resData = res.data;
              if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                  this.$toast.center(resData.message);
                  setTimeout(() => {
                    this.count = 1;
                    this.$router.push('/orderStatus?bz=' + this.currency)
                  }, 1000)
              }else{
                this.count = 1;
                this.isMask = false;
                this.isPay = false;
                this.inputList = [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}];
                this.$toast.center(resData.message);
                return;
              }
          }).catch(function(err){
              console.log(err)
          })
      },
      goTop(){
          $('.cont-box').animate({scrollTop:'0px'},'slow');
       }
    },
    filters: {
        statusText: (val) => {
            if(val == 0){
                return that.xsh
            }else if(val == 1){
                return ''
            }
        },
        times: function(timestamp){
            var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-');
            var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
            var h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
            var m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
            var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
            return Y + M + D;
        }
    },
    watch: {
        amount: function(val){
            if(val > this.cont.limit_buy){
                this.amount = this.cont.limit_buy;
                this.totlaMoney = this.amount * this.cont.money;
            }else if(val == ''){
                this.amount = '';
                this.totlaMoney = this.amount * this.cont.money;
            }else if(val == 0){
                this.amount = 1;
                this.totlaMoney = this.amount * this.cont.money;
            }else{
                this.amount = val;
                this.totlaMoney = this.amount * this.cont.money;
            }
        }
    },
    components:{
        noData,
        VueCircle
    }
}
</script>
<style scoped>
    input::-webkit-input-placeholder{
        color: #C4C4C4;
        font-size: .28rem;
    }
    .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;
        color: #cecece;
        font-size: .48rem;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
        overflow: hidden;
    }
    .head{
        position: fixed;
        left: 0;
        top: 0;
        z-index: 999;
        width: 100%;
        height: 1.6rem;
        padding: 0 .24rem;
        color: #fff;
        font-size: .56rem;
        line-height: 1.6rem;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
      position: absolute;
      left: .4rem;
      top: 50%;
      width: .32rem;
      height: .6rem;
      margin-top: -.3rem;
    }
    .head .icon{
        position: absolute;
        right: .24rem;
        top: 50%;
        width: .54rem;
        transform: translateY(-50%);
    }
    .cont-box{
        position: absolute;
        left: 0;
        right: 0;
        top: 1.6rem;
        bottom: 0;
        height: auto;
        color: #cecece;
        font-size: .48rem;
        overflow-y: scroll;
    }
    .ul-box{
        padding: .48rem .3rem 0 .3rem;
    }
    .ul-box .list{
        position: relative;
        margin-bottom: .28rem;
    }
    .ul-box .list .list-head{
        position: relative;
        display: flex;
        justify-content: space-between;
        width: 100%;
        margin: 0 .6rem 0 .2rem;
        padding: .72rem .9rem .72rem .2rem;
        box-sizing: border-box;
    }
    .ul-box .list .list-head .list-left{
        position: relative;
        width: 2.58rem;
        height: 2.4rem;
        text-align: center;
    }
    .ul-box .list .list-right{
        position: absolute;
        right: .5rem;
        top: 1rem;
    }
    .ul-box .list .list-right .sl-box{
        width: 2rem;
        height: 1.6rem;
        margin: auto;
        color: #00BEFF;
        font-size: .4rem;
        text-align: center;
    }
    .ul-box .list .list-right .sl-text{
        width: 2rem;
        padding-top: .48rem;
        color: #406D8E;
        font-size: .36rem;
        text-align: center;
    }
    .ul-box .list .list-head .bg1{
        position: absolute;
        left: 0;
        top: 0;
        width: 2.58rem;
        height: 2.5rem;
    }
    .ul-box .list .list-head .text{
        position: relative;
        z-index: 100;
        width: 1rem;
        margin: auto;
        padding-top: .7rem;
        color: #fff;
        font-size: .4rem;
    }
    .ul-box .list .list-head .num{
        position: relative;
        z-index: 100;
        padding-top: .1rem;
        color: #fff;
        font-size: .28rem;
    }
    .ul-box .list .list-head .num.btn-buy{
        position: absolute;
        left: 50%;
        top: 50%;
        width: .8rem;
        margin: auto;
        font-size: .28rem;
        word-break: break-all;
        word-break: break-word;
        transform: translate(-50%,-55%);
    }
    .ul-box .list .list-head .num.width-en{
        width: 1.2rem;
    }
    .ul-box .list .border{
        position: absolute;
    }
    .ul-box .list .border1{
        left: 0;
        top: 0;
        width: .38rem;
        height: .32rem;
        border-top: 2px solid #44CFFF;
        border-left: 2px solid #44CFFF;
    }
    .ul-box .list .border2{
        top: 0;
        right: .35rem;
        width: .38rem;
        height: .32rem;
        border-top: 2px solid #44CFFF;
        border-right: 2px solid #44CFFF;
    }
    .ul-box .list .border3{
        left: 0;
        bottom: 0;
        width: .38rem;
        height: .32rem;
        border-bottom: 2px solid #44CFFF;
        border-left: 2px solid #44CFFF;
    }
    .ul-box .list .border4{
        right: .35rem;
        bottom: 0;
        width: .38rem;
        height: .32rem;
        border-bottom: 2px solid #44CFFF;
        border-right: 2px solid #44CFFF;
    }
    .ul-box .list .border5{
        left: 0;
        top: 0;
        width: .48rem;
        height: .32rem;
        border-top: 2px solid #fff;
        border-left: 2px solid #fff;
    }
    .ul-box .list .type{
        position: absolute;
        top: 0;
        left: 2.3rem;
        height: .7rem;
        padding: 0 .2rem;
        color: #fff;
        font-size: .36rem;
        line-height: .7rem;
        border-left: 4px solid #39AAD6;
        background: #0F2439;
        text-align: center;

    }
    .ul-box .list .type.ty-box{
        top: -.4rem;
        left: 50%;
        width: 2.5rem;
        font-size: .26rem;
        border-right: .05rem solid #39AAD6;
        transform: translateX(-50%);
    }
    .ul-box .list .type.circly-box1{
        left: 2.9rem;
        top: .6rem;
        font-size: .28rem;
        border-left: none;
        background: transparent;
    }
    .ul-box .list .type.circly-box{
        left: 2.9rem;
        top: 1.1rem;
    }
    .ul-box .list .type.rwk{
        left: 2.7rem;
        top: 1.8rem;
        width: 2.4rem;
        height: auto;
        padding: 0 .1rem;
        border-left: .05rem solid #39AAD6;
        text-align: left;
    }
    .ul-box .list .type.rwkWauto{
        width: auto;
    }
    .ul-box .list .type.money{
        left: 3rem;
        top: .52rem;
    }
    .ul-box .list .type.money2{
        left: 3.5rem;
        top: 1.5rem;
    }
    .ul-box .list .type.money3{
        left: 3rem;
        top: 2.5rem;
    }
    .ul-box .list .xian1{
        position: absolute;
        left: 1.9rem;
        top: 0;
        width: .24rem;
        height: .32rem;
    }
    .ul-box .list .xian3{
        position: absolute;
        left: 2.66rem;
        top: 1.3rem;
        width: .24rem;
        height: .32rem;
    }
    .ul-box .list .xian4{
        position: absolute;
        left: 2.66rem;
        top: .8rem;
        width: .24rem;
        height: .32rem;
    }
    .ul-box .list .star-box{
        position: absolute;
        left: 2.24rem;
        top: -.3rem;
        display: flex;
        align-items: center;
        color: #fff;
        font-size: .4rem;
    }
    .ul-box .list .star-box .tips{
        padding-right: .12rem;
    }
    .ul-box .list .star-box .star{
        width: .28rem;
        height: .28rem;
        margin-right: .04rem;
    }
    .ul-box .list .xian2{
        position: absolute;
        left: 2.6rem;
        top: 1.66rem;
        width: .3rem;
        height: .26rem;
    }
    .ul-box .list .btn{
        position: absolute;
        left: 2.9rem;
        top: 1.9rem;
        padding: .1rem .2rem;
        color: #fff;
        font-size: .28rem;
        line-height: .4rem;
        background: rgba(26, 50, 73,.5);
    }
    .ul-box .list .bg-line{
        width: 100%;
        margin-top: .38rem;
    }
    .status{
        position: absolute;
        right: 0;
        top: 0;
        padding: .12rem .22rem;
        color: #fff;
        font-size: .24rem;
        background: #2CAADE;
        border-radius: 0px 10px 0px 10px;
    }
    .status.active{
        background: #9D9D9D;
    }
    .download-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: fixed;
        left: 2%;
        bottom: 1.2rem;
        width: 96%;
        height: 1.2rem;
        padding: 0 .1rem;
        border-radius: 4px;
        background: #3381d5;
        box-sizing: border-box;
    }
    .download-box .logo{
        width: .5rem;
        height: .5rem;
    }
    .download-box .text-box .t1{
        font-size: .26rem;
        margin-bottom: .08rem;
    }
    .download-box .text-box{
        flex: 1;
        margin: 0 .1rem;
        color: #fff;
        font-size: .24rem;
    }
    .download-box .btn{
        margin-right: .3rem;
        padding: .1rem .2rem;
        color: #000;
        font-size: .24rem;
        border-radius: 4px;
        background: #fff;
        text-align: center;
    }
    .download-box .btn-close{
        position: absolute;
        right: .06rem;
        top: .06rem;
        z-index: 999;
        width: .28rem;
        height: .28rem;
    }
    .alert-wrap{
        position: absolute;
        left: 1.3rem;
        right: 1.18rem;
        top: 50%;
        z-index: 1000;
        width: auto;
        background: #1A2440;
        border-radius: .2rem;
        transform: translateY(-50%);
    }
    .alert-wrap .alert-head,.alert-wrap2 .alert-head{
        position: relative;
        padding: .28rem 0 .5rem;
        color: #fff;
        font-size: .32rem;
        text-align: center;
    }
    .alert-wrap .alert-head .icon,.alert-wrap2 .alert-head .icon{
        position: absolute;
        right: .3rem;
        top: .3rem;
        width: .3rem;
        height: .3rem;
    }
    .alert-wrap .cont{
        max-height: 6rem;
        padding: 0 .8rem .72rem .72rem;
        color: #fff;
        font-size: .28rem;
        overflow: auto;
    }
    .alert-pay{
        left: .72rem;
        right: .72rem;
        background: rgba(26 ,36, 63,.9);
    }
    .alert-pay .alert-head{
        padding: .5rem .4rem;
        font-size: .28rem;
        border-bottom: 1px solid #858585;
    }
    .alert-pay .close{
        position: absolute;
        right: .16rem;
        top: .2rem;
        width: .3rem;
    }
    .alert-pay .alert-btn{
        padding: .3rem 0;
        color: #2CAADE;
        font-size: .32rem;
        text-align: center;
    }
    .alert-wrap2 .alert-head{
        position: relative;
        padding: .28rem 0 .5rem;
        color: #fff;
        font-size: .32rem;
        text-align: center;
    }
    .alert-wrap2 .alert-head .icon{
        position: absolute;
        right: .3rem;
        top: .3rem;
        width: .3rem;
        height: .3rem;
    }
    .alert-wrap2{
        position: absolute;
        left: .72rem;
        right: .72rem;
        top: 50%;
        z-index: 1000;
        width: auto;
        background: #1A2440;
        border-radius: .2rem;
        transform: translateY(-50%);
    }
    .alert-wrap2 .tips{
        padding: 0 .44rem .44rem;
        color: #D1D1D1;
        font-size: .24rem;
        text-align: center;
    }
    .alert-wrap2 .btn-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .alert-wrap2 .btn-box .btn{
        width: 50%;
        height: .9rem;
        color: #fff;
        font-size: .32rem;
        text-align: center;
    }
    .alert-wrap2 .btn-box .reset{
        background: #4F608E;
        border-radius: 0 0 0 .2rem;
    }
    .alert-wrap2 .btn-box .sure{
        background: #677DB9;
        border-radius: 0 0 .2rem 0;
    }
    .alert-wrap2 .xys-box{
        padding: 0 .5rem .48rem;
    }
    .alert-wrap2 .list{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .16rem .08rem;
        font-size: .32rem;
        border-bottom: 1px solid #484e5e;
    }
    .alert-wrap2 .list .time{
        color: #777981;
    }
    .alert-wrap2 .list .num{
        color: #2CAADE;
    }
    .alert-cont-box{
        height: 7.6rem;
        overflow-y: auto;
    }
    .alert-wrap3{
        position: absolute;
        left: .15rem;
        right: .15rem;
        bottom: 0;
        z-index: 1000;
        padding: .48rem .1rem .28rem;
        background: rgba(26, 36, 63, .9);
        border-radius: .2rem;
    }
    .alert-wrap3 .tips{
        color: #fff;
        font-size: .48rem;
        text-align: center;
    }
    .alert-wrap3 .btn-close{
        position: absolute;
        right: .48rem;
        top: .48rem;
        width: .6rem;
        height: .6rem;
    }
    .alert-wrap3 .ul-box{
        padding: .7rem 0 .3rem;
    }
    .alert-wrap3 .ul-box .list{
        display: flex;
        align-items: center;
    }
    .alert-wrap3 .ul-box .list .img{
        width: 1.3rem;
    }
    .alert-wrap3 .ul-box .list .info-box{
        flex: 1;
        margin-left: .1rem;
        color: #cecece;
        font-size: .34rem;
    }
    .alert-wrap3 .ul-box .list .info-box .title{
        color: #fff;
        font-size: .4rem;
    }
    .alert-wrap3 .ul-box .list .info-box .red{
        padding-left: .06rem;
        color: #E02626!important;
        font-size: .24rem;
    }
    .alert-wrap3 .ul-box .list .info-box .price-box{
        display: flex;
        justify-content: space-between;
        margin-top: .3rem;
        font-size: .34rem;
    }
    .alert-wrap3 .ul-box .list .info-box .sl-box{
        display: flex;
        justify-content: space-between;
        margin-top: .3rem;
    }
    .alert-wrap3 .ul-box .list .info-box .text1{
        flex: 1.5;
    }
    .alert-wrap3 .ul-box .list .info-box .text2{
        flex: 1;
    }
    .alert-wrap3 .num-wrap{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .22rem .42rem;
        color: #fff;
        font-size: .28rem;
        background: rgba(4, 9, 37, .8);
        border-radius: .26rem;
    }
    .alert-wrap3 .num-wrap .icon{
        width: .38rem;
        height: .38rem;
    }
    .alert-wrap3 .input-box{
        margin: .38rem 0 .62rem;
    }
    .alert-wrap3 .input-box .input{
        width: 100%;
        height: 1.2rem;
        color: #fff;
        font-size: .4rem;
        padding: 0 .36rem;
        background: rgba(4, 9, 37, .8);
        border-radius: .26rem;
        box-sizing: border-box;
    }
    .alert-wrap3 .input-box .input::placeholder{
      color: #666;
      font-size: .4rem;
    }
    .alert-wrap3 .num-box{
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    .alert-wrap3 .num-box .input{
        width: .8rem;
        color: #fff;
        font-size: .28rem;
        background: #040A26;
        text-align: center;
    }
    .alert-wrap3 .pay-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: auto;
        height: 1.2rem;
        color: #fff;
        font-size: .36rem;
        background: #040A26;
        border-radius: .46rem;
    }
    .alert-wrap3 .pay-box .t1{
        width: 70%;
        padding-left: .2rem;
    }
    .alert-wrap3 .pay-box .t1 .reds{
        padding-left: .16rem;
        color: #2caade;
        font-size: .4rem;
    }
    .alert-wrap3 .pay-box .t1 small{
        font-size: .4rem;
    }
    .alert-wrap3 .pay-box .t2{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 30%;
      height: 1.2rem;
      font-size: .36rem;
      background: rgba(44, 170, 222,.5);
      border-radius: 0 .46rem .46rem 0;
      text-align: center;
    }
    .alert-wrap3 .money{
      color: #fff;
      font-size: .4rem;
    }
</style>
<style scoped>
    .progress .circle-progress-value {
        stroke-width: 6px;
        stroke: #eb47b4;
        stroke-dasharray: 4 1;
    }
    .progress .circle-progress-circle {
        stroke-width: 6px;
        stroke: #eee;
    }
    .progress .circle-progress-text {
        font-weight: bold;
        fill: #18d8d8;
    }
    .select-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 1.2rem;
      margin: 0 .3rem .3rem;
      padding: 0 .4rem;
      border-radius: .4rem;
      background: rgba(26, 36, 63, .5);;
    }
    .select-box .text{
      flex: 1;
      color: #fff;
      font-size: .4rem;
    }
    .select-box .bz{
      margin-right: .2rem;
      color: #fff;
      font-size: .4rem;
    }
    .select-box .arrow{
      width: .2rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/loan.vue